<div class="login-page">

  <div class="login-container">

    <!-- LOGO -->
    <div class="brand">
      <img
        src="../../assets/images/aluprof_biale_logo.png"
        alt="Aluprof Aluminium Systems"
        class="brand-logo">
    </div>


    <!-- SLOGAN -->
    <div class="brand-slogan">
      Nowoczesne rozwiązania.
      <span>Prostsze zamówienia.</span>
    </div>


    <!-- JĘZYK -->
    <div class="language-wrapper">

      <mat-form-field
        class="language-select"
        appearance="outline">

        <mat-select
          [(value)]="Lang"
          (valueChange)="changeLanguage()">

          <mat-select-trigger>

            <mat-icon
              class="flaga flaga{{Lang}}">
            </mat-icon>

            <span class="jezyk_login">
              {{Lang | translate}}
            </span>

          </mat-select-trigger>

          <mat-option
            *ngFor="let language of this.translateService.langs"
            [value]="language">

            <mat-icon
              class="flaga flaga{{language}}">
            </mat-icon>

            {{language | translate}}

          </mat-option>

        </mat-select>

      </mat-form-field>

    </div>


    <!-- LOGIN CARD -->
    <div class="login-card">

      <div class="login-heading">
        <div class="login-title">
          System zamówień B2B
        </div>

        <div class="login-subtitle">
          Zaloguj się, aby kontynuować
        </div>
      </div>


      <!-- USERNAME -->
      <mat-form-field
        class="login-field"
        appearance="outline">

        <mat-label>
          {{'nazwa_uzytkownika' | translate}}
        </mat-label>

        <span matPrefix>
          <mat-icon>account_circle</mat-icon>
        </span>

        <input
          matInput
          type="text"
          [(ngModel)]="Username"
          (keyup.enter)="login()">

      </mat-form-field>


      <!-- PASSWORD -->
      <mat-form-field
        class="login-field"
        appearance="outline">

        <mat-label>
          {{'haslo' | translate}}
        </mat-label>

        <span matPrefix>
          <mat-icon>lock</mat-icon>
        </span>

        <input
          matInput
          type="password"
          [(ngModel)]="Password"
          (keyup.enter)="login()">

      </mat-form-field>


      <!-- LOGIN BUTTON -->
      <button
        mat-flat-button
        class="login-button"
        type="button"
        (click)="login()">

        <span>
          {{'zaloguj' | translate}}
        </span>

        <mat-icon>
          arrow_forward
        </mat-icon>

      </button>


      <!-- LINKS -->
      <div class="login-actions">

        <button
          mat-button
          (click)="openContactDialog()">

          <mat-icon>
            support_agent
          </mat-icon>

          {{'kontakt' | translate}}

        </button>

        <button
          mat-button
          (click)="resetPassword()">

          <mat-icon>
            lock_reset
          </mat-icon>

          {{'resetuj_haslo' | translate}}

        </button>

      </div>

    </div>


    <!-- FOOTER -->
    <div class="login-footer">

      <span>
        Powered by
      </span>

      <a
        href="https://www.aliprof.com"
        target="_blank"
        rel="noopener noreferrer">

        Aluprof

      </a>

      <span class="footer-dot"></span>

      <span>
        Aluminium Systems
      </span>

    </div>

  </div>

</div>